
import { Component, Vue, namespace } from 'nuxt-property-decorator';
import FourwavesLogoFull from 'fourwaves-shared/src/images/fourwaves-dark-full.png';
import { TranslateResult } from 'vue-i18n';

const EventsModule = namespace('events');

@Component
export default class FourwavesBadge extends Vue {
  @EventsModule.State eventId!: string;
  @EventsModule.State isWhiteLabel!: boolean;

  readonly FourwavesLogoFull = FourwavesLogoFull;

  isVisible = true;
  randomValue: number = 0;

  get variantName(): 'variantA' | 'variantB' {
    return this.randomValue > 0.5 ? 'variantA' : 'variantB';
  }

  get badgeTitle(): TranslateResult {
    return this.$t(`fourwaves_badge.${this.variantName}.title`);
  }

  get badgeLink(): TranslateResult {
    return this.$t(`fourwaves_badge.${this.variantName}.link`, { eventId: this.eventId });
  }

  public created(): void {
    this.$eventBus.on('footer:visibility-enter', this.onFourwavesBadgeVisibilityEnter);
    this.$eventBus.on('footer:visibility-leave', this.onFourwavesBadgeVisibilityLeave);
  }

  public mounted(): void {
    this.randomValue = Math.random();
  }

  public beforeDestroy(): void {
    this.$eventBus.off('footer:visibility-enter', this.onFourwavesBadgeVisibilityEnter);
    this.$eventBus.off('footer:visibility-leave', this.onFourwavesBadgeVisibilityLeave);
  }

  public onFourwavesBadgeVisibilityEnter(): void {
    this.isVisible = false;
  }

  public onFourwavesBadgeVisibilityLeave(): void {
    this.isVisible = true;
  }
}
